/**
 *
 */
export enum LCFStepCompletion {
  NotStarted = 1,
  Partially = 2,
  Completed = 3,
  Optional = 4,
}
